import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { defaultDesktopBreakpoint } from '../breakpoints';
import MountedProvider from '../MountedProvider';

var Mobile =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Mobile, _Component);

  function Mobile() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Mobile.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        onChange = _this$props.onChange,
        theme = _this$props.theme;
    var desktopThemeBreakpoint = theme ? theme.breakpoints[theme.desktopBreakpoint] : null;
    var desktopBreakpoint = desktopThemeBreakpoint || defaultDesktopBreakpoint;
    return React.createElement(MountedProvider.Consumer, null, function (isMounted) {
      return React.createElement(Media, {
        query: "(max-width: " + (desktopBreakpoint - 1) + "px)",
        onChange: onChange
      }, function (matches) {
        var showMobOnMount = isMounted ? matches : true;
        return showMobOnMount ? children : null;
      });
    });
  };

  return Mobile;
}(Component);

_defineProperty(Mobile, "propTypes", {
  /**
   * The content to be rendered on Mobile only.
   */
  children: PropTypes.node,

  /**
   * Callback function that will be invoked when the status of the media query changes.
   *This can be useful for triggering side effects, independent of the render lifecycle.
   */
  onChange: PropTypes.func
});

_defineProperty(Mobile, "defaultProps", {
  children: null
});

export default withTheme(Mobile);